(function () {
  const TIMEZONE_OPTIONS = [
    { value: 'America/Anchorage', label: 'Anchorage, AK (GMT-8)' },
    { value: 'America/Los_Angeles', label: 'Los Angeles, CA (GMT-7)' },
    { value: 'America/Denver', label: 'Denver, CO (GMT-6)' },
    { value: 'America/Chicago', label: 'Chicago, IL (GMT-5)' },
    { value: 'America/New_York', label: 'New York, NY (GMT-4)' },
    { value: 'Europe/London', label: 'London, UK (GMT+0)' },
    { value: 'Europe/Paris', label: 'Paris, FR (GMT+1)' },
  ];
  const TIMEZONE_LABELS = new Map(TIMEZONE_OPTIONS.map((option) => [option.value, option.label]));

  const pages = document.querySelectorAll('[data-designer-appointment-page]');
  if (!pages.length) {
    return;
  }

  pages.forEach((page) => {
    const endpoint = page.dataset.apiEndpoint || '/apps/ai-pearl-designer';
    const customerEmail = page.dataset.customerEmail || '';
    const customerName = page.dataset.customerName || '';
    const customerId = page.dataset.customerId || '';
    const customerOrderCount = Number(page.dataset.customerOrderCount || 0);
    const shopDomain = page.dataset.shopDomain || '';
    const summaryRoot = page.querySelector('[data-role="booking-page-summary"]');
    const form = page.querySelector('[data-role="booking-page-form"]');
    const status = page.querySelector('[data-role="booking-page-status"]');
    const submit = page.querySelector('[data-role="booking-page-submit"]');
    const submitLabel = submit?.querySelector('.pearl-designer__button-label');
    const paymentNotice = page.querySelector('[data-role="booking-payment-notice"]');

    if (!form || !summaryRoot) {
      return;
    }

    const appointmentEndpoint = joinPath(endpoint, 'appointment');
    const appointmentPaymentSessionEndpoint = joinPath(endpoint, 'appointment-payment-session');
    const appointmentAvailabilityEndpoint = joinPath(endpoint, 'appointment-availability');
    const historyImageEndpoint = joinPath(endpoint, 'history/image');
    const params = new URLSearchParams(window.location.search);
    const generationId = String(params.get('generation_id') || '').trim();
    let bookingContext = null;
    let availabilityContext = null;
    let calendarWindowStartKey = '';
    let selectedDateKey = '';

    const timezoneInput = form.elements.timezone;
    const slotDayInput = form.elements.appointment_day;
    const slotSelect = form.elements.selected_slot_utc;
    const slotDayList = page.querySelector('[data-role="booking-slot-day-list"]');
    const slotList = page.querySelector('[data-role="booking-slot-list"]');
    const calendarMonth = page.querySelector('[data-role="booking-calendar-month"]');
    const calendarPrev = page.querySelector('[data-role="booking-calendar-prev"]');
    const calendarNext = page.querySelector('[data-role="booking-calendar-next"]');
    const selectedDayCopy = page.querySelector('[data-role="booking-selected-day-copy"]');
    const selectedDayCount = page.querySelector('[data-role="booking-selected-day-count"]');

    if (!generationId) {
      summaryRoot.innerHTML = placeholderMarkup(
        'No design selected',
        'Return to the AI designer page, choose your favorite concept, then open the booking page again.'
      );
      setStatus(status, 'A selected concept is required before booking.', 'error');
      updateCheckoutButtonState(false);
      return;
    }

    if (paymentNotice) {
      paymentNotice.hidden = false;
      paymentNotice.textContent =
        'Our jewelry specialist will review your design and prepare for your consultation. Please check your email for the confirmation and appointment link. If you are not satisfied with the result, you can use it as credit to purchase any product on our website.';
    }
    updateCheckoutButtonState(false);

    calendarPrev?.addEventListener('click', () => shiftCalendarWindow(-7));
    calendarNext?.addEventListener('click', () => shiftCalendarWindow(7));
    timezoneInput?.addEventListener('change', () => {
      selectedDateKey = '';
      calendarWindowStartKey = '';
      if (slotDayInput) slotDayInput.value = '';
      if (slotSelect) slotSelect.value = '';
      updateCheckoutButtonState(false);
      loadAvailability(bookingContext?.booking?.id || null);
    });

    loadBookingContext();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!bookingContext?.generation?.id) {
        setStatus(status, 'We could not load your selected design yet.', 'error');
        return;
      }

      const formData = new FormData(form);
      const payload = {
        generationId: bookingContext.generation.id,
        customerEmail,
        customerName: String(formData.get('contact_name') || customerName || '').trim(),
        customerId,
        customerOrderCount,
        shopDomain,
        contactEmail: String(formData.get('contact_email') || '').trim(),
        contactPhone: String(formData.get('contact_phone') || '').trim(),
        timezone: String(formData.get('timezone') || '').trim(),
        selectedSlotUtc: String(formData.get('selected_slot_utc') || '').trim(),
        notes: String(formData.get('notes') || '').trim(),
      };

      if (!payload.contactEmail) {
        setStatus(status, 'Please enter the best email for your consultation.', 'error');
        return;
      }

      if (!payload.timezone) {
        setStatus(status, 'Please confirm your timezone before submitting.', 'error');
        return;
      }

      if (!payload.selectedSlotUtc) {
        setStatus(status, 'Please select an available appointment time.', 'error');
        return;
      }

      const isExistingBooking = Boolean(
        bookingContext?.booking?.id && bookingContext?.booking?.isPaymentAuthorized
      );
      submit.disabled = true;
      setStatus(
        status,
        isExistingBooking
          ? 'Updating your appointment request...'
          : 'Preparing your secure checkout...',
        'loading'
      );

      try {
        const response = await fetch(
          isExistingBooking ? appointmentEndpoint : appointmentPaymentSessionEndpoint,
          {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
          }
        );
        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(
            responseJson.error ||
              (isExistingBooking
                ? 'Unable to update your appointment request.'
                : 'Unable to prepare checkout.')
          );
        }

        if (isExistingBooking) {
          bookingContext.booking = responseJson.booking || bookingContext.booking;
          setStatus(
            status,
            'Your appointment request has been updated successfully.',
            'success'
          );
          return;
        }

        if (!responseJson.checkoutUrl) {
          throw new Error('Checkout link is missing.');
        }
        window.location.href = responseJson.checkoutUrl;
      } catch (error) {
        setStatus(
          status,
          error.message ||
            (isExistingBooking
              ? 'Unable to update your appointment request right now.'
              : 'Unable to prepare checkout right now.'),
          'error'
        );
      } finally {
        submit.disabled = false;
      }
    });

    async function loadBookingContext() {
      setStatus(status, 'Loading your selected concept...', 'loading');

      try {
        const response = await fetch(
          `${appointmentEndpoint}?generationId=${encodeURIComponent(generationId)}&_ts=${Date.now()}`,
          {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
          }
        );
        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(responseJson.error || 'Unable to load the selected concept.');
        }

        bookingContext = responseJson;
        renderSummary(responseJson.generation);
        hydrateForm(responseJson.booking);
        await loadAvailability(responseJson.booking?.id || null);
        setStatus(
          status,
          responseJson.booking?.id
            ? responseJson.booking.isPaymentAuthorized
              ? 'A paid appointment request already exists for this concept. You can update and resubmit it below.'
              : 'This concept has an older unpaid appointment request. Choose your time and continue to secure checkout again.'
            : 'Choose your preferred time, then continue to secure checkout.',
          responseJson.booking?.id ? 'success' : 'loading'
        );
        updateCheckoutButtonState(
          Boolean(
            responseJson.booking?.isPaymentAuthorized
              ? responseJson.booking?.scheduledAt
              : responseJson.booking?.scheduledAt || responseJson.booking?.preferredDate
          )
        );
      } catch (error) {
        summaryRoot.innerHTML = placeholderMarkup(
          'Unable to load your selected concept',
          error.message || 'Please return to the AI designer page and try again.'
        );
        setStatus(status, error.message || 'Unable to load the selected concept.', 'error');
        updateCheckoutButtonState(false);
      }
    }

    async function loadAvailability(excludeBookingId) {
      if (!timezoneInput) {
        return;
      }

      const timezone = String(timezoneInput.value || '').trim();
      if (!timezone) {
        availabilityContext = null;
        renderTimezoneSelectionState(page);
        return;
      }

      try {
        const query = new URLSearchParams({ timezone });
        if (excludeBookingId) {
          query.set('excludeBookingId', String(excludeBookingId));
        }

        const response = await fetch(
          `${appointmentAvailabilityEndpoint}?${query.toString()}&_ts=${Date.now()}`,
          {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
          }
        );
        const responseJson = await parseApiResponse(response);
        if (!response.ok || responseJson.ok === false) {
          throw new Error(responseJson.error || 'Unable to load appointment availability.');
        }

        availabilityContext = responseJson;
        renderAvailability(responseJson);
      } catch (error) {
        availabilityContext = null;
        if (slotDayList) {
          slotDayList.innerHTML = selectionEmptyMarkup('Availability unavailable');
        }
        if (slotList) {
          slotList.innerHTML = selectionEmptyMarkup('Reload to retry');
        }
      }
    }

    function renderAvailability(responseJson) {
      const slotDays = Array.isArray(responseJson?.slotDays) ? responseJson.slotDays : [];
      if (!slotDays.length) {
        calendarWindowStartKey = '';
        selectedDateKey = '';
        if (slotDayInput) slotDayInput.value = '';
        if (slotSelect) slotSelect.value = '';
        if (slotDayList) slotDayList.innerHTML = selectionEmptyMarkup('No open dates available');
        if (slotList) slotList.innerHTML = selectionEmptyMarkup('No times available');
        if (calendarMonth) calendarMonth.textContent = 'No availability';
        if (selectedDayCopy) selectedDayCopy.textContent = 'No times available.';
        if (selectedDayCount) selectedDayCount.textContent = '0 open';
        updateCheckoutButtonState(false);
        return;
      }

      const minimumBookableDateKey = getMinimumBookableDateKey();
      const displayStartDateKey = getDisplayStartDateKey();
      const bookedMatch = bookingContext?.booking?.scheduledAt
        ? findSlotByUtc(slotDays, bookingContext.booking.scheduledAt)
        : null;
      const fallbackDateKey =
        bookedMatch?.day?.dateKey ||
        getFirstBookableSlotDayKey(slotDays, minimumBookableDateKey) ||
        slotDays[0].dateKey;
      selectedDateKey = getResolvedSelectedDateKey(slotDays, selectedDateKey, fallbackDateKey, minimumBookableDateKey);
      calendarWindowStartKey = getWindowStartKey(selectedDateKey, calendarWindowStartKey, displayStartDateKey);
      renderCalendar(slotDays);
      renderSelectedDay(slotDays);

      if (bookedMatch) {
        selectSlot(bookedMatch.slot, bookedMatch.day);
      } else {
        if (slotSelect) {
          slotSelect.value = '';
        }
        updateCheckoutButtonState(false);
      }
    }

    function renderCalendar(slotDays) {
      if (!slotDayList || !calendarMonth) {
        return;
      }

      const minimumBookableDateKey = getMinimumBookableDateKey();
      const displayStartDateKey = getDisplayStartDateKey();
      const windowStartKey = getWindowStartKey(selectedDateKey || slotDays[0].dateKey, calendarWindowStartKey, displayStartDateKey);
      const windowDays = buildCalendarDays(windowStartKey, slotDays, minimumBookableDateKey);
      calendarWindowStartKey = windowDays[0]?.dateKey || windowStartKey;
      calendarMonth.textContent = formatCalendarWindowTitle(windowDays);
      if (calendarPrev) {
        calendarPrev.disabled = calendarWindowStartKey <= displayStartDateKey;
      }
      slotDayList.innerHTML = windowDays
        .map(
          (day) => `
            <button
              class="pearl-designer__booking-calendar-day${day.isAvailable ? ' is-available' : ''}${day.isSelected ? ' is-selected' : ''}${day.isBlocked ? ' is-blocked' : ''}"
              type="button"
              data-role="booking-calendar-day"
              data-date-key="${escapeHtml(day.dateKey)}"
              ${day.isAvailable && !day.isBlocked ? '' : 'disabled'}
            >
              <span class="pearl-designer__booking-calendar-day-label">${escapeHtml(day.weekdayShort)}</span>
              <span class="pearl-designer__booking-calendar-day-bubble">
                <span class="pearl-designer__booking-calendar-day-number">${escapeHtml(String(day.dayNumber))}</span>
              </span>
            </button>
          `
        )
        .join('');

      slotDayList.onclick = (event) => {
        const trigger = event.target.closest('[data-role="booking-calendar-day"]');
        if (!trigger) {
          return;
        }

        const nextDay = getDayByDateKey(slotDays, String(trigger.dataset.dateKey || '').trim());
        if (!nextDay) {
          return;
        }

        selectedDateKey = nextDay.dateKey;
        if (slotDayInput) {
          slotDayInput.value = nextDay.dateKey;
        }
        if (slotSelect) {
          slotSelect.value = '';
        }
        renderCalendar(slotDays);
        renderSelectedDay(slotDays);
        if (nextDay.slots[0]) {
          selectSlot(nextDay.slots[0], nextDay);
        }
      };
    }

    function renderSelectedDay(slotDays) {
      if (!slotList || !slotSelect) {
        return;
      }

      const day = getDayByDateKey(slotDays, selectedDateKey);
      if (!day) {
        slotList.innerHTML = selectionEmptyMarkup('Pick a day');
        slotSelect.value = '';
        if (selectedDayCopy) selectedDayCopy.textContent = 'Pick a day to view times.';
        if (selectedDayCount) selectedDayCount.textContent = '0 open';
        return;
      }

      if (slotDayInput) {
        slotDayInput.value = day.dateKey;
      }
      if (selectedDayCopy) {
        selectedDayCopy.textContent = '';
      }
      if (selectedDayCount) {
        selectedDayCount.textContent = `${day.slots.length} open`;
      }

      slotList.innerHTML = day.slots.length
        ? day.slots
            .map(
              (slot) => `
                <button
                  class="pearl-designer__booking-slot"
                  type="button"
                  data-role="booking-slot-option"
                  data-slot-utc="${escapeHtml(slot.utc)}"
                >
                  <span class="pearl-designer__booking-slot-primary">${escapeHtml(getAppointmentStartLabel(slot.localLabel))}</span>
                </button>
              `
            )
            .join('')
        : selectionEmptyMarkup('No times for this day');

      slotList.onclick = (event) => {
        const trigger = event.target.closest('[data-role="booking-slot-option"]');
        if (!trigger) {
          return;
        }

        const selectedSlot = day.slots.find(
          (item) => item.utc === String(trigger.dataset.slotUtc || '').trim()
        );
        if (selectedSlot) {
          selectSlot(selectedSlot, day);
        }
      };
    }

    function selectBookedSlot(utcValue, slotDays) {
      const match = findSlotByUtc(slotDays, utcValue);
      if (!match) {
        return;
      }

      selectedDateKey = match.day.dateKey;
      if (slotDayInput) {
        slotDayInput.value = match.day.dateKey;
      }
      renderCalendar(slotDays);
      renderSelectedDay(slotDays);
      selectSlot(match.slot, match.day);
    }

    function selectSlot(slot, day) {
      if (!slotSelect || !slot) {
        return;
      }

      slotSelect.value = slot.utc;
      updateCheckoutButtonState(true);
      updateSelectedChoice(slotList, `[data-slot-utc="${cssEscape(slot.utc)}"]`);
    }

    function updateCheckoutButtonState(hasSlotSelected) {
      if (!submit) {
        return;
      }

      const canUpdateAuthorizedBooking = Boolean(
        bookingContext?.booking?.id && bookingContext?.booking?.isPaymentAuthorized
      );
      submit.disabled = !hasSlotSelected;
      if (submitLabel) {
        submitLabel.textContent = !hasSlotSelected
          ? 'Select a Time First'
          : canUpdateAuthorizedBooking
            ? 'Update Appointment Request'
            : 'Pay refundable deposit';
      }
    }

    function findSlotByUtc(slotDays, utcValue) {
      const normalized = String(utcValue || '').trim();
      if (!normalized) {
        return null;
      }

      for (const day of slotDays || []) {
        const slot = (day.slots || []).find((item) => item.utc === normalized);
        if (slot) {
          return { day, slot };
        }
      }

      return null;
    }

    function shiftCalendarWindow(delta) {
      if (!availabilityContext?.slotDays?.length) {
        return;
      }

      const displayStartDateKey = getDisplayStartDateKey();
      const startKey = getWindowStartKey(
        selectedDateKey || availabilityContext.slotDays[0].dateKey,
        calendarWindowStartKey,
        displayStartDateKey
      );
      const nextKey = shiftDateKey(startKey, delta);
      if (delta < 0 && nextKey < displayStartDateKey) {
        calendarWindowStartKey = displayStartDateKey;
      } else {
        calendarWindowStartKey = nextKey;
      }
      renderCalendar(availabilityContext.slotDays);
    }

    function getDayByDateKey(slotDays, dateKey) {
      return (slotDays || []).find((day) => day.dateKey === dateKey) || null;
    }

    function buildCalendarDays(startDateKey, slotDays, minimumBookableDateKey) {
      const startDate = parseDateKey(startDateKey);
      const dayMap = new Map((slotDays || []).map((day) => [day.dateKey, day]));

      return Array.from({ length: 7 }, (_, index) => {
        const date = new Date(startDate);
        date.setUTCDate(startDate.getUTCDate() + index);
        const dateKey = formatDateKey(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        const slotDay = dayMap.get(dateKey);

        return {
          dateKey,
          dayNumber: date.getUTCDate(),
          weekdayShort: formatWeekdayShort(date),
          isBlocked: dateKey < minimumBookableDateKey,
          isAvailable: Boolean(slotDay?.slots?.length),
          isSelected: dateKey === selectedDateKey,
        };
      });
    }

    function renderSummary(generation) {
      if (!generation) {
        summaryRoot.innerHTML = placeholderMarkup(
          'No concept available',
          'Return to the AI designer page and select a design first.'
        );
        return;
      }

      const conceptTitle = formatConceptTitle(generation);
      const estimateLabel = formatMoneyRange(generation.estimate);
      const createdAtLabel = generation.createdAt ? formatDate(generation.createdAt) : 'Recently generated';
      const sizeLabel = Number(generation.pearlSizeMm || 0) > 0 ? `${Number(generation.pearlSizeMm)}mm` : 'To be confirmed';

      summaryRoot.innerHTML = `
        <article class="pearl-designer__appointment-booking-card">
          <div class="pearl-designer__appointment-booking-media">
            <img
              src="${historyImageEndpoint}/${encodeURIComponent(String(generation.id))}?variant=full"
              alt="${escapeHtml(conceptTitle || 'Selected jewelry concept')}"
              loading="eager"
              fetchpriority="high"
            >
          </div>
          <div class="pearl-designer__appointment-booking-body">
            <div class="pearl-designer__appointment-booking-header">
              <div class="pearl-designer__appointment-booking-meta">
                <span>Selected Design</span>
                <strong>${escapeHtml(conceptTitle)}</strong>
                <p>${escapeHtml(buildAppointmentSummaryCopy(generation))}</p>
              </div>
              <div class="pearl-designer__appointment-booking-badges">
                <span class="pearl-designer__appointment-booking-badge"><strong>${escapeHtml(estimateLabel)}</strong></span>
                <span class="pearl-designer__appointment-booking-badge">${escapeHtml(createdAtLabel)}</span>
              </div>
            </div>
            <div class="pearl-designer__appointment-card-specs">
              <div class="pearl-designer__appointment-card-spec"><span>Pearl</span><strong>${escapeHtml(humanizeLabel(generation.pearlType) || 'N/A')}</strong></div>
              <div class="pearl-designer__appointment-card-spec"><span>Size</span><strong>${escapeHtml(sizeLabel)}</strong></div>
              <div class="pearl-designer__appointment-card-spec"><span>Metal</span><strong>${escapeHtml(humanizeLabel(generation.metalMaterial) || 'N/A')}</strong></div>
              <div class="pearl-designer__appointment-card-spec"><span>Gemstone</span><strong>${escapeHtml(humanizeLabel(generation.diamondQuality) || 'N/A')}</strong></div>
              <div class="pearl-designer__appointment-card-range"><span>Estimate</span><strong>${escapeHtml(estimateLabel)}</strong></div>
            </div>
            <div class="pearl-designer__appointment-booking-footer">
              <strong>Consultation Focus</strong>
              <p>Your designer will use this saved concept as the visual starting point for silhouette, material balance, and final pricing discussion.</p>
            </div>
          </div>
        </article>
      `;
    }

    function hydrateForm(booking) {
      if (!booking) {
        return;
      }

      if (form.elements.contact_name && !form.elements.contact_name.value) {
        form.elements.contact_name.value = booking.customerName || customerName || '';
      }
      if (form.elements.contact_email) {
        form.elements.contact_email.value = booking.contactEmail || customerEmail || '';
      }
      if (form.elements.contact_phone) {
        form.elements.contact_phone.value = booking.contactPhone || '';
      }
      if (form.elements.timezone) {
        form.elements.timezone.value = isSupportedTimezone(booking.timezone) ? booking.timezone : '';
      }
      if (form.elements.notes) {
        form.elements.notes.value = booking.notes || '';
      }
    }
  });

  function renderTimezoneSelectionState(page) {
    const slotDayList = page?.querySelector('[data-role="booking-slot-day-list"]');
    const slotList = page?.querySelector('[data-role="booking-slot-list"]');
    const calendarMonth = page?.querySelector('[data-role="booking-calendar-month"]');
    const selectedDayCopy = page?.querySelector('[data-role="booking-selected-day-copy"]');
    const selectedDayCount = page?.querySelector('[data-role="booking-selected-day-count"]');

    if (slotDayList) slotDayList.innerHTML = selectionEmptyMarkup('Unavailable today and tomorrow');
    if (slotList) slotList.innerHTML = selectionEmptyMarkup('Choose a timezone');
    if (calendarMonth) calendarMonth.textContent = 'Select timezone';
    if (selectedDayCopy) selectedDayCopy.textContent = 'Choose a timezone first.';
    if (selectedDayCount) selectedDayCount.textContent = '0 open';
  }

  function isSupportedTimezone(value) {
    return TIMEZONE_LABELS.has(String(value || '').trim());
  }

  function getAppointmentStartLabel(label) {
    const normalized = String(label || '').trim();
    if (!normalized) {
      return '';
    }

    return normalized.split(' - ')[0] || normalized;
  }

  function formatConceptTitle(generation) {
    const metalLabel = humanizeLabel(generation?.metalMaterial) || '';
    const jewelryLabel = humanizeLabel(generation?.jewelryType) || 'Selected concept';
    return [metalLabel, jewelryLabel].filter(Boolean).join(' ') || 'Selected concept';
  }

  function buildAppointmentSummaryCopy(generation) {
    const pearlLabel = humanizeLabel(generation?.pearlType) || 'pearl';
    const sizeLabel = Number(generation?.pearlSizeMm || 0) > 0 ? `${Number(generation.pearlSizeMm)}mm` : 'custom-sized';
    return `A saved ${sizeLabel} ${pearlLabel.toLowerCase()} direction, ready for your private consultation and final refinement.`;
  }

  function placeholderMarkup(title, copy) {
    return `<div class="pearl-designer__placeholder"><div><strong>${escapeHtml(title)}</strong>${escapeHtml(copy)}</div></div>`;
  }

  function setStatus(node, message, state) {
    if (!node) {
      return;
    }

    node.textContent = message;
    node.dataset.state = state;
    node.hidden = state !== 'error';
  }

  function formatMoneyRange(estimate) {
    if (!estimate) {
      return 'Pending estimate';
    }

    try {
      const formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: estimate.currency || 'USD',
        maximumFractionDigits: 0,
      });
      return `${formatter.format(estimate.minimum || 0)} - ${formatter.format(estimate.maximum || 0)}`;
    } catch (error) {
      return `${estimate.currency || 'USD'} ${estimate.minimum || 0} - ${estimate.maximum || 0}`;
    }
  }

  function formatDate(value) {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return String(value || '').trim() || 'Recently generated';
    }

    try {
      return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }).format(parsed);
    } catch (error) {
      return String(value || '').trim() || 'Recently generated';
    }
  }

  function humanizeLabel(value) {
    const labels = {
      ring: 'Ring',
      necklace: 'Necklace',
      earrings: 'Earrings',
      bracelet: 'Bracelet',
      pendant: 'Pendant',
      brooch: 'Brooch',
      freshwater: 'Freshwater Pearl',
      akoya: 'Akoya Pearl',
      tahitian: 'Tahitian Pearl',
      south_sea: 'South Sea Pearl',
      mabe: 'Mabe Pearl',
      silver: 'Silver',
      gold_vermeil: 'Gold Vermeil',
      gold_14k_yellow: '14K Yellow Gold',
      gold_14k_white: '14K White Gold',
      gold_18k_yellow: '18K Yellow Gold',
      gold_18k_white: '18K White Gold',
      gold_18k_rose: '18K Rose Gold',
      imitation_diamond: 'Imitation Diamond',
      labgrown_diamond: 'Lab-Grown Diamond',
      natural_diamond: 'Natural Diamond',
    };

    if (labels[value]) {
      return labels[value];
    }

    return String(value || '')
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  async function parseApiResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const bodyText = await response.text();

    if (contentType.includes('application/json')) {
      try {
        return JSON.parse(bodyText);
      } catch (error) {
        throw new Error('The API returned malformed JSON.');
      }
    }

    if (!response.ok) {
      return {
        error: 'The API returned non-JSON content.',
      };
    }

    throw new Error('The API returned non-JSON content.');
  }

  function joinPath(base, suffix) {
    const trimmedBase = String(base || '').replace(/\/+$/, '');
    return `${trimmedBase}/${suffix}`;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function selectionEmptyMarkup(message) {
    return `<div class="pearl-designer__choice-empty">${escapeHtml(message)}</div>`;
  }

  function updateSelectedChoice(root, nextNode) {
    if (!root) {
      return;
    }

    root.querySelectorAll('.is-selected').forEach((node) => node.classList.remove('is-selected'));
    const resolved =
      typeof nextNode === 'string' ? root.querySelector(nextNode) : nextNode;
    resolved?.classList.add('is-selected');
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function formatCalendarWindowTitle(windowDays) {
    const firstDay = windowDays[0];
    const lastDay = windowDays[windowDays.length - 1];
    if (!firstDay || !lastDay) {
      return 'Select a date';
    }

    const firstDate = parseDateKey(firstDay.dateKey);
    const lastDate = parseDateKey(lastDay.dateKey);
    const firstLabel = new Intl.DateTimeFormat(undefined, {
      timeZone: 'UTC',
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    }).format(firstDate);
    const lastLabel = new Intl.DateTimeFormat(undefined, {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
    }).format(lastDate);

    return `${firstLabel} - ${lastLabel}`;
  }

  function formatWeekdayShort(date) {
    return new Intl.DateTimeFormat(undefined, {
      timeZone: 'UTC',
      weekday: 'short',
    }).format(date);
  }

  function parseDateKey(dateKey) {
    const [year, month, day] = String(dateKey || '').split('-').map(Number);
    return new Date(Date.UTC(year || 2026, (month || 1) - 1, day || 1));
  }

  function shiftDateKey(dateKey, deltaDays) {
    const date = parseDateKey(dateKey);
    date.setUTCDate(date.getUTCDate() + deltaDays);
    return formatDateKey(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
  }

  function getWindowStartKey(fallbackDateKey, currentStartKey, displayStartDateKey) {
    const normalizedCurrent = String(currentStartKey || '').trim();
    if (normalizedCurrent) {
      return normalizedCurrent < displayStartDateKey ? displayStartDateKey : normalizedCurrent;
    }

    return String(displayStartDateKey || fallbackDateKey || '').trim();
  }

  function getResolvedSelectedDateKey(slotDays, currentSelectedDateKey, fallbackDateKey, minimumBookableDateKey) {
    const normalizedCurrent = String(currentSelectedDateKey || '').trim();
    if (normalizedCurrent && normalizedCurrent >= minimumBookableDateKey) {
      return normalizedCurrent;
    }

    return String(fallbackDateKey || getFirstBookableSlotDayKey(slotDays, minimumBookableDateKey) || '').trim();
  }

  function getFirstBookableSlotDayKey(slotDays, minimumBookableDateKey) {
    return (
      (slotDays || []).find((day) => day.dateKey >= minimumBookableDateKey && Array.isArray(day.slots) && day.slots.length)?.dateKey ||
      (slotDays || []).find((day) => day.dateKey >= minimumBookableDateKey)?.dateKey ||
      ''
    );
  }

  function getMinimumBookableDateKey() {
    return shiftDateKey(getDisplayStartDateKey(), 3);
  }

  function getDisplayStartDateKey() {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return formatDateKey(now.getFullYear(), now.getMonth() + 1, now.getDate());
  }

  function formatDateKey(year, month, day) {
    return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }
})();
